module.exports = __webpack_public_path__ + "img/1338.5ca8af2f.gif";